import { render, staticRenderFns } from "./roleManageModal.vue?vue&type=template&id=02e3cbea&scoped=true&"
import script from "./roleManageModal.vue?vue&type=script&lang=js&"
export * from "./roleManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e3cbea",
  null
  
)

export default component.exports